import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function SpinnerText({ loading, icon, text, className, ...rest }) {
  if (!loading)
    return (
      <>
        {icon ? (
          <>
            <i className={icon}></i>
            {text}
          </>
        ) : (
          text
        )}
      </>
    );

  return (
    <span className={classnames("spinner-text", className)} {...rest}>
      <i className="far fa-spinner fa-spin"></i>
      {text}
    </span>
  );
}

SpinnerText.propTypes = {
  loading: PropTypes.bool.isRequired,
  text: PropTypes.string,
};

export default SpinnerText;
